<template>
    <div>
		<el-card class="box-card" v-loading="dataLoading">
		    <div slot="header" class="clearfix">
		        <span>
		            <span class="el-icon-data-line"></span> 汇总统计 <span class="color-danger">（通票的销售数据会进行单独展示，不会包含在场次的销售数据中）</span>
		        </span>
		    </div>
			<div class="page-list-box">				
			    <el-table :data="data.sessionList" border style="width: 100%"  size="small" stripe v-if="data && data.sessionList">
			        <el-table-column prop="name" label="演出场次"></el-table-column>               
			        <el-table-column prop="totalNum" label="总票数"></el-table-column>
			        <el-table-column prop="sellNum" label="当前销售"></el-table-column>			        
			        <el-table-column prop="remainder" label="剩余可售"></el-table-column>
			        <el-table-column prop="sellRate" label="当前出票率"></el-table-column>
					<el-table-column  label="销售金额">
						<template slot-scope="scope">
							<p>票品金额：{{scope.row.sellAmount}}</p>
							<p>乐迷服务费：{{scope.row.userServiceFee}}</p>
						</template>
					</el-table-column>
					<el-table-column label="优惠">
						<template slot-scope="scope">
							<p>秀动承担优惠：{{scope.row.discountAmount}}</p>
							<p>B类承担优惠：{{scope.row.busDiscountAmount}}</p>
						</template>
					</el-table-column>
			        <el-table-column  label="实际收入">
						<template slot-scope="scope">
							<p>票品金额：{{scope.row.income}}</p>
							<p>乐迷服务费：{{scope.row.userServiceFee}}</p>
						</template>
					</el-table-column>
					<el-table-column  label="退票">
						<template slot-scope="scope">
							<p>退票数：{{scope.row.cancelNum}}</p>
							<p>退票手续费：{{scope.row.refundFeeStr}}</p>
						</template>
					</el-table-column>
			    </el-table>
			</div>
		</el-card>
		<el-card class="box-card MT20" v-loading="dataLoading">
			<div slot="header" class="clearfix">
			    <span>
			        <span class="el-icon-data-line"></span> 分时统计 <span class="color-danger">（注意：分时统计展示的是历史销售数据，即当时售出的门票数（包括后来可能取消的门票），而非当前实际销售票数）</span>
			    </span>
			</div>
			<div v-if="ticketNameData">
			    <el-row :gutter="20">
					<el-col :sm="12">
						<el-row :gutter="10">        
							<el-col :span="16">
								<el-select v-model="sessionIdText" placeholder="请选择" @change="changeActivity" clearable style="width: 100%;">	
									<el-option label="整场演出" value=""></el-option>
									<el-option v-for="(item, index) in ticketNameData" :key="index" :label="item.name" :value="item.id"></el-option>
								</el-select>
							</el-col>
							<el-col :span="8">
								<el-radio-group v-model="timeType" @change="getTime" style="white-space: nowrap;">
									<el-radio-button :label="0">小时</el-radio-button>
									<el-radio-button :label="1">天</el-radio-button>
								</el-radio-group>
							</el-col>	
						</el-row>	
					</el-col>			
			        <el-col :sm="12" >
						<el-date-picker v-model="daterange" type="daterange" range-separator="-" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd HH:mm:ss" :clearable="false" unlink-panels :picker-options="pickerOptions" @change="daterangeChange" style="width: 100%;"></el-date-picker>
			        </el-col>
			    </el-row>
				<div class="color-danger">按小时统计只能看最多7天的数据，按天统计只能看最多一年的数据</div>
			</div>
			<div class="content">
			   <div id="chartContainer" ref="chartContainer"></div>
			</div>
		</el-card>
		<el-card class="box-card MT20" v-loading="dataLoading">
			<div slot="header" class="clearfix">
			    <span>
			        <span class="el-icon-data-line"></span> 渠道销售占比 <br><br>
					<small>
						<span class="color-danger">统计当前演出下（或者跟当前演出绑定的所有演出）不同渠道的销售占比</span>
						<p class="color-danger">注意：这里统计展示的是历史销售数据，即当时销售的订单金额（包括后来可能取消的订单），而非当前实际销售金额</p>
					</small>
			    </span>
			</div>			
			<div class="content"  v-if="data && data.thirdList">
			   <div id="chartContainerThird"></div>
			</div>
		</el-card>
       
    </div>
</template>

<script>
import { Chart } from '@antv/g2';
export default {
    props: {
        activityId: {
            type: [Number, String],
            default: () => null
        },
		// data:{
		// 	type: Object,
		// 	default: null,
		// },
		ticketNameData:{
			type: Array,
			default: () => {
				return [];
			}
		}
		
    },
    components: {},
    data() {
        return {
            dataLoading: false,	
			daterange: [],			
			activityType:0,
			timeType:1,
			startTime:'',
			endTime:'',
			sessionId:'',
			ticketId:'',
			sessionIdText:'',
			timeData:null,
			chart:null,
			chart1:null,
			thirdList:[],
			data:{},
			sessionList: null,
			pickerMinDate1: "",//第一次选中的时间
			pickerOptions: {
			    onPick: obj => {
			        this.pickerMinDate1 = new Date(obj.minDate).getTime();
			    },
			    disabledDate: (time) => {
			        if (this.pickerMinDate1 && time.getTime() <= Date.now()) {
			            const day1 = 730 * 24 * 3600 * 1000;
			            let maxTime = this.pickerMinDate1 + day1;
			            let minTime = this.pickerMinDate1 - day1;
			            return time.getTime() > maxTime || time.getTime() < minTime;
			        }else{
			            return time.getTime() > Date.now();
			        }
			    }
			},
        }
    }, 
	mounted() {
	    this.getTime(1)
		this.drawCharts()		
	},
    methods: {
		drawCharts(){
			this.dataLoading = true
			this.$request({
			    url: "/activity/statistics/summary",
			    params: { id: parseInt(this.activityId) },
			    method: "post",
			})
			    .then((res) => {
			        const { state, msg, result } = res.data;
			        if (state == 1) {
						this.data = result
			            this.thirdList = this.data.thirdList;
						if(this.data.thirdList && this.data.thirdList.length > 0 ){
							this.dataLoading = false
							this.$nextTick(() => {
								this.drawChart1();
							})
						}
			        } else {
			            this.$message.error(msg || "获取信息失败,请重试");
			        }
			    })
			    .catch(() => {
			        this.$message.error("获取信息失败,请重试");
			    })
			    .finally(() => {
			        this.dataLoading = false;
			    });
		},
		drawChart1(){
		    if( this.chart1 ) this.chart1.destroy();
		    let _data = this.thirdList
			
		    _data.map( v => {
		        v.ratio = parseFloat(v.ratio);
		    })
		    this.chart1 = new Chart({
		        container: 'chartContainerThird',
		        autoFit: true,
		        height: 120,
		    });
		    this.chart1.data(_data);
		    this.chart1.interaction('active-region');    
		
		    this.chart1.tooltip({
		        showTitle: false,
		        showMarkers: false,
		    });
		    this.chart1
		        .interval()
		        .position('name*ratio')
		        .size(30)
		        .tooltip('name*ratio', (name, ratio) => {
		            ratio = '销售'+ parseFloat(ratio) + '%';
		            return {
		                name: name,
		                value: ratio,
		            };
		        });
		    this.chart1.render();
		},
      getTime(val){		  
		this.$request({
		    url: "/activity/statistics/time",
		    data: {},
		    method: "post",
		})
		    .then((res) => {
		        const { state, msg, result } = res.data;
		        if (state == 1) {
		            if( val == 1 ){
						this.daterange = [result[1].startTime,result[1].endTime]
						
					}else{
						this.daterange = [result[0].startTime,result[0].endTime]
					}
					this.getTimedata()
					
		        } else {
		            this.$message.error(msg || "获取数据失败,请重试");
		        }
		    })
		    .catch(() => {
		        this.$message.error("获取数据失败,请重试");
		    })
		    .finally(() => {
		        this.dataLoading = false;
		    });  
	  }, 
	  changeActivity(value){
		 
		  if( value.length == 32 ){
			this.ticketId = value || ''
			this.sessionId = ''
			this.getTimedata()
		  }else{
			this.ticketId = ''
			this.sessionId = value || ''
			this.getTimedata()
		  }	
	  },
	   getTimedata(){
		   this.dataLoading = true
		   this.$request({
		       url: "/activity/statistics/timeStats",
		       data: { 
				   activityId: parseInt(this.activityId),
				   startTime:this.daterange && this.daterange[0] || '',
				   endTime:this.daterange && this.daterange[1] || '',
				   sessionId:this.sessionId,				   
				   timeType:this.timeType,
				   ticketId:this.ticketId
				},
		       method: "post",
		   })
		       .then((res) => {
		           const { state, msg, result } = res.data;
		           if (state == 1) {
		               this.timeData = result;
					   this.dataLoading = false;
					   this.$nextTick(() => {
							this.drawChart();
					   })
		           } else {
		               this.$message.error(msg || "获取数据失败,请重试");
		           }
		       })
		       .catch(() => {
		           this.$message.error("获取数据失败,请重试");
		       })
		       .finally(() => {
		           this.dataLoading = false;
		       });
	   },
	   drawChart(){
	       if( this.chart ) this.chart.destroy();
		   let _data = [];
		   _data = [...this.timeData];
		   
	       _data.map(v => {
	           v.value = parseFloat(v.value)
	       })
	   
	      this.chart = new Chart({
	          container: 'chartContainer',
	          autoFit: true,
	          height: 300,
	      });
	      this.chart.data(_data);
	      
	      this.chart.tooltip({
	          showTitle: false,
	          showMarkers: false,
	          showCrosshairs: true,
	          itemTpl: '<div><div class="g2-tooltip-title" style="font-size:14px;font-weight:700;">{name}（销售票数：{value}）</div><ul class="g2-tooltip-list">{rank}</ul></div>',
	      });
	      
	      if( _data.length > 30 ){
	          this.chart.option('slider', {
	              start: (_data.length - 30) / _data.length,
	              end: 1,
	          });
	      }
	      this.chart
	          .line()
	          .position('name*value')
	          .shape('smooth')
	          .tooltip('name*value', (name,value) => {
	              return {
	                  name: name,
	                  value: value,
	                 
	              };
	          });
	      
	      this.chart.render();
	       
	   },
	   
	   //选择自定义时间段
	   daterangeChange(e){
	      this.getTimedata()
	   }
	   
    }
}
</script>